import { useQuery } from "@tanstack/react-query";

import { useSupabaseClient } from "@/hooks/use-supabase-client";
import type { Page, PageEditor } from "@/types/database";

// Site-wide roster of delegated ("den leader") access, for the People
// screen — usePageEditors (use-page-editors.ts) is scoped to one page at a
// time, which is all Page Settings' own Access tab ever needs.
export function useSitePageEditors(pages: Page[]) {
  const getClient = useSupabaseClient();
  const pageIds = pages.map((page) => page.id);

  return useQuery({
    queryKey: ["site-page-editors", pageIds],
    enabled: pageIds.length > 0,
    queryFn: async (): Promise<PageEditor[]> => {
      const supabase = await getClient();
      const { data, error } = await supabase.from("page_editors" as any).select("*").in("page_id", pageIds);
      if (error) throw error;
      return (data ?? []) as unknown as PageEditor[];
    },
  });
}
